// extracted by mini-css-extract-plugin
export var category = "CategoryAndDate-module--category--DEUGQ";
export var date = "CategoryAndDate-module--date--LDVeB";
export var root = "CategoryAndDate-module--root--eDQvH";